import { Injectable } from '@angular/core';
import { NumberUtility } from '../appUtilities/number.utility';
import { UserService } from './user/user.service';
import { CashMgmtService } from './cash-mgmt.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessingFeeService {
  percentCommission:number;
  instantDepositConfig: any;

  constructor(
    private numberUtility: NumberUtility,
    private userService: UserService,
    private cashMgmtService: CashMgmtService
  ) { 
    this.getSalesmanCommission();
    this.getInstantDepositConfig();
  }




  private getSalesmanCommission() {
    this.userService.getSalesman().subscribe(res=>{
      // console.log(res);
      this.percentCommission = res[0]?.percentCommission || 0;
    })
  }


  /**
   * Get instant deposit config
   */
  getInstantDepositConfig(){
    // this.cashMgmtService.getConfiguration('instantDeposit').subscribe(res=>{
    //     this.instantDepositConfig = res.value;
    // })
  }


  /**
   * Get calculated platform fee amount for second transaction of card reader
   * @param totalAmount 
   * @param stripeProcessingFees 
   * @returns 
   */
  getCalculatedTotalAmountForStripeCardReader(
    totalAmount: number,
    subtotal: number,
    stripeProcessingFees: any
  ): number {

    let fixed_fee = stripeProcessingFees?.inPersonFixedFee || 0;
    let percent_fee = stripeProcessingFees?.inPersonFeePercentageFee * 0.01 || 0;

    const platformFee = this.getPlatformFeeFromRules(
      totalAmount,
      stripeProcessingFees?.platformFeeRules,
      stripeProcessingFees?.platformFee
    );

    const amountToRestaurant = this.numberUtility.roundToTwo((subtotal + fixed_fee) / (1 - percent_fee));
    return amountToRestaurant;
  }



  /**
   * Get calculated platform fee amount for second transaction of card reader
   * @param totalAmount 
   * @param stripeProcessingFees 
   * @returns 
   */
  getCalculatedPlatformFeeAmount(
    totalAmount: number,
    stripeProcessingFees: any
  ): number {

    let fixed_fee = stripeProcessingFees?.inPersonFixedFee || 0;
    let percent_fee = stripeProcessingFees?.inPersonFeePercentageFee * 0.01 || 0;

    const platformFee = this.getPlatformFeeFromRules(
      totalAmount,
      stripeProcessingFees?.platformFeeRules,
      stripeProcessingFees?.platformFee
    );

    const amountToTastio = this.numberUtility.roundToTwo((platformFee + fixed_fee) / (1 - percent_fee));
    return amountToTastio;
  }

  
  calculateStripeProcessingFee(
    paymentMethod: any,
    totalAmount: number,
    stripeProcessingFees: any
  ): number {
    let processingFee = 0;
    let fixed_fee = 0;
    let percent_fee = 0;
    let amountToPay = 0;

    if (paymentMethod.toUpperCase() === 'CARD PAYMENT') {
      fixed_fee = stripeProcessingFees?.fixedFee;
      percent_fee = stripeProcessingFees?.percentageFee * 0.01;
    }

    if (paymentMethod.toUpperCase() === 'CARD READER') {
      fixed_fee = stripeProcessingFees?.inPersonFixedFee;
      percent_fee = stripeProcessingFees?.inPersonFeePercentageFee * 0.01;
    }

    const platformFee = this.getPlatformFeeFromRules(
      totalAmount,
      stripeProcessingFees?.platformFeeRules,
      stripeProcessingFees?.platformFee
    );

    amountToPay = (totalAmount + platformFee + fixed_fee) / (1 - percent_fee);

    processingFee = this.numberUtility.roundToTwo(amountToPay - totalAmount);

    return processingFee;
  }

  getPlatformFeeFromRules(totalAmount: number, platformFeeRules: any[], defaultPlatformFee: number): number {
    if (!platformFeeRules || !Array.isArray(platformFeeRules) || platformFeeRules.length < 1) {
      return Number(defaultPlatformFee) || 0;
    }

    let result = 0;
    let platformFeeType = 'fixed';

    for (let i = 0; i < platformFeeRules.length; i++) {
      const min = Number(platformFeeRules[i].minOrderAmount);
      const max = Number(platformFeeRules[i].maxOrderAmount);

      if (totalAmount > min && totalAmount <= max) {
        result = Number(platformFeeRules[i].fee) || 0;
        platformFeeType = (platformFeeRules[i].platformFeeType || 'fixed').toLowerCase();
        break;
      }
    }

    const fallbackFee = Number(defaultPlatformFee) || 0;
    const platformFee = result > 0 ? result : fallbackFee;

    if (platformFeeType === 'fixed') {
      return platformFee;
    }

    return this.numberUtility.roundToTwo((platformFee * totalAmount) / 100);
  }
  
}
